import { render } from "./Archive_store.vue?vue&type=template&id=36be7223"
import script from "./Archive_store.vue?vue&type=script&lang=js"
export * from "./Archive_store.vue?vue&type=script&lang=js"
script.render = render

export default script